import React from 'react';
import { FaArrowLeft } from '@react-icons/all-files/fa/FaArrowLeft';
import { FaSave } from '@react-icons/all-files/fa/FaSave';

const ACCENT = '#8b5cf6';

export function ServicioAsignadoModalActions({
  formId,
  updating,
  submitLabel,
  onClose,
}: {
  formId: string;
  updating: boolean;
  submitLabel: string;
  onClose: () => void;
}) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 10,
        paddingTop: 16,
        marginTop: 8,
        borderTop: '1px solid var(--crm-border)',
      }}
    >
      <button
        type="button"
        className="profase-form-btn-secondary d-inline-flex align-items-center"
        style={{ padding: '9px 20px', fontSize: 13, fontWeight: 600 }}
        onClick={onClose}
        disabled={updating}
      >
        <FaArrowLeft style={{ marginRight: 6 }} />
        Cancelar
      </button>
      <button
        type="submit"
        form={formId}
        className="btn d-inline-flex align-items-center text-white border-0"
        style={{ padding: '9px 20px', fontSize: 13, fontWeight: 600, background: ACCENT }}
        disabled={updating}
      >
        <FaSave style={{ marginRight: 6 }} />
        {updating ? 'Guardando…' : submitLabel}
      </button>
    </div>
  );
}

export const SERVICIO_ASIGNADO_FORM_ID = 'servicio-asignado-form';

export function servicioAsignadoModalDialogClassName(wide: boolean): string {
  return wide ? 'profase-modal-dialog--large' : '';
}

/** @deprecated use servicioAsignadoModalDialogClassName with ProfaseModal size prop */
export function servicioAsignadoModalDialogStyle(wide: boolean): React.CSSProperties {
  return wide ? {} : { maxWidth: 560, maxHeight: 'min(90vh, 720px)' };
}

export function servicioAsignadoModalBodyGridStyle(): React.CSSProperties {
  return {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
    gap: 24,
    alignItems: 'stretch',
  };
}
